import MenuItem from "@mui/material/MenuItem";
import { useColorScheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

import { SettingsPage } from "~/components/settings/SettingsPage";

type Mode = "system" | "light" | "dark";

const MODES: Mode[] = ["system", "light", "dark"];

/**
 * Light or dark.
 *
 * Device-only: MUI persists the choice locally and there is no server field for it, so
 * this screen needs neither `useProfileSave` nor save feedback. A member on two devices
 * can reasonably want dark on the phone and light on the desktop.
 */
export function AppearanceRoute() {
  const { t } = useTranslation();
  const { mode, setMode } = useColorScheme();

  return (
    <SettingsPage
      title={t("profile.appearance.title")}
      description={t("profile.appearance.description")}
    >
      <TextField
        select
        label={t("profile.appearance.label")}
        value={mode ?? "system"}
        onChange={(event) => setMode(event.target.value as Mode)}
        fullWidth
        slotProps={{ htmlInput: { "data-testid": "profile.appearance" } }}
      >
        {MODES.map((value) => (
          <MenuItem key={value} value={value}>
            {t(`appearance.${value}`)}
          </MenuItem>
        ))}
      </TextField>
    </SettingsPage>
  );
}
